import {Injectable, signal} from '@angular/core';
import {modalPath} from "../configs/base-design-block-modal-config";

@Injectable({
  providedIn: 'root'
})
export class BaseDesignBlockPathStateService {
  private _pathState = signal<string>('');
  public pathState = this._pathState.asReadonly();

  public setPathState(modalKey: string): void {
    this._pathState.set(modalPath[modalKey]);
  }

  public resetPathState(): void {
    this._pathState.set('');
  }
}
